import React from "react";

export default function MSAccess_TimeSerial() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_TimeSerial</h1>
      <p>This is the MSAccess_TimeSerial component generated from the SQL JSON.</p>
    </div>
  );
}
